<template>
  <div class="third-app-detail">
    <el-card class="box-card" shadow="never">
      <template #header>
        <div class="card-header">
          <span class="card-title">应用信息</span>
          <el-button type="primary" @click="goBack">返回列表</el-button>
        </div>
      </template>
      <el-descriptions :column="2" border>
        <el-descriptions-item label="应用ID">{{ detailInfo.id }}</el-descriptions-item>
        <el-descriptions-item label="应用名称">{{ detailInfo.appName }}</el-descriptions-item>
        <el-descriptions-item label="应用Key">{{ detailInfo.appKey }}</el-descriptions-item>
        <el-descriptions-item label="应用密钥">{{ detailInfo.appSecret }}</el-descriptions-item>
        <el-descriptions-item label="状态">
          <el-tag :type="detailInfo.status === 1 ? 'success' : 'danger'">
            {{ detailInfo.status === 1 ? '启用' : '禁用' }}
          </el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="过期时间">{{ detailInfo.expireTime || '永不过期' }}</el-descriptions-item>
        <el-descriptions-item label="备注" :span="2">{{ detailInfo.remark || '--' }}</el-descriptions-item>
      </el-descriptions>
    </el-card>

    <el-card class="box-card api-card" shadow="never">
      <template #header>
        <div class="card-header">
          <span class="card-title">已授权API权限列表</span>
        </div>
      </template>

      <div class="api-permission-actions">
        <el-button type="danger" @click="batchRevoke()" :disabled="selectedApiIds.length === 0">
          批量撤销
        </el-button>
        <span class="selected-count" v-if="selectedApiIds.length > 0">
          已选择 {{ selectedApiIds.length }} 项
        </span>
      </div>

      <el-form :inline="true" class="search-form">
        <el-form-item label="接口名称">
          <el-input v-model="apiSearchForm.apiName" placeholder="请输入接口名称" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="searchApiList()">搜索</el-button>
          <el-button @click="resetApiSearch()">重置</el-button>
        </el-form-item>
      </el-form>

      <el-table 
        ref="apiTableRef"
        class="table_wrapper" 
        :data="apiTableData" 
        :header-cell-style="{'text-align':'left'}" 
        :cell-style="{'text-align':'left'}"
        @selection-change="handleApiSelectionChange"
        row-key="permissionCode"
      >
        <el-table-column type="selection" width="55" :reserve-selection="true"></el-table-column>
        <el-table-column label="接口名称" prop="apiName" min-width="150" show-overflow-tooltip></el-table-column>
        <el-table-column label="接口URI" prop="apiUri" min-width="200" show-overflow-tooltip></el-table-column>
        <el-table-column label="请求方法" prop="method" width="100">
          <template #default="scope">
            <el-tag :type="getMethodType(scope.row.method)" size="small">
              {{ scope.row.method }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="权限编码" prop="permissionCode" width="150"></el-table-column>
        <el-table-column label="接口描述" prop="description" min-width="150" show-overflow-tooltip></el-table-column>
        <el-table-column label="状态" width="80">
          <template #default="scope">
            <el-tag :type="scope.row.status === 1 ? 'success' : 'danger'" size="small">
              {{ scope.row.status === 1 ? '启用' : '禁用' }}
            </el-tag>
          </template>
        </el-table-column>
      </el-table>

      <!-- API资源分页 -->
      <Pagination
        v-model:current-page="apiCurrentPage"
        v-model:page-size="apiPageSize"
        :total="apiTotal"
        @size-change="handleApiSizeChange"
        @current-change="handleApiCurrentChange"
      />
    </el-card>

    <el-card class="box-card station-card" shadow="never">
      <template #header>
        <div class="card-header">
          <span class="card-title">已授权场站权限列表</span>
        </div>
      </template>

      <div class="api-permission-actions">
        <el-button type="danger" @click="batchRevokeStation()" :disabled="selectedStationIds.length === 0">
          批量撤销
        </el-button>
        <span class="selected-count" v-if="selectedStationIds.length > 0">
          已选择 {{ selectedStationIds.length }} 项
        </span>
      </div>

      <el-form :inline="true" class="search-form">
        <el-form-item label="场站名称">
          <el-input v-model="stationSearchForm.name" placeholder="请输入场站名称" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="searchStationList()">搜索</el-button>
          <el-button @click="resetStationSearch()">重置</el-button>
        </el-form-item>
      </el-form>

      <el-table 
        ref="stationTableRef"
        class="table_wrapper" 
        :data="stationTableData" 
        :header-cell-style="{'text-align':'left'}" 
        :cell-style="{'text-align':'left'}"
        @selection-change="handleStationSelectionChange"
        row-key="stationId"
      >
        <el-table-column type="selection" width="55" :reserve-selection="true"></el-table-column>
        <el-table-column label="场站ID" prop="stationId" width="100"></el-table-column>
        <el-table-column label="场站名称" prop="stationName" min-width="200" show-overflow-tooltip></el-table-column>
        <el-table-column label="详细地址" prop="address" min-width="300" show-overflow-tooltip></el-table-column>
      </el-table>

      <!-- 场站资源分页 -->
      <Pagination
        v-model:current-page="stationCurrentPage"
        v-model:page-size="stationPageSize"
        :total="stationTotal"
        @size-change="handleStationSizeChange"
        @current-change="handleStationCurrentChange"
      />
    </el-card>
  </div>
</template>

<script>
import { ElMessage } from 'element-plus';
export default {
  name: 'ThirdAppDetail',
  data() {
    return {
      appKey: '',
      detailInfo: {
        appId: '',
        appName: '',
        appKey: '',
        appSecret: '',
        status: 1,
        expireTime: '',
        remark: '',
      },
      apiTableData: [],
      apiTotal: 0,
      apiCurrentPage: 1,
      apiPageSize: 10,
      apiSearchForm: {
        apiName: '',
      },
      selectedApiIds: [],
      stationTableData: [],
      stationTotal: 0,
      stationCurrentPage: 1,
      stationPageSize: 10,
      stationSearchForm: {
        name: '',
      },
      selectedStationIds: [],
    };
  },
  created() {
    this.appKey = this.$route.params.appKey;
    this.getAppDetail();
  },
  methods: {
    getAppDetail() {
      let that = this;
      that.$axios.post("open-server/openapi/admin/apps/" + that.appKey).then(result => {
        if (result.code == 200) {
          that.detailInfo = result.data;
          that.getApiList();
          that.getStationList();
        }
      });
    },
    getApiList() {
      let that = this;
      let param = {};
      param.current = that.apiCurrentPage;
      param.size = that.apiPageSize;
      param.apiName = that.apiSearchForm.apiName;
      param.appId = that.detailInfo.id;
      that.$axios.post("open-server/openapi/api/pageByAppId", JSON.stringify(param)).then(result => {
        if (result.code == 200) {
          that.apiTableData = result.data.records;
          that.apiTotal = result.data.total;
        }
      });
    },
    searchApiList() {
      this.apiCurrentPage = 1;
      this.getApiList();
    },
    resetApiSearch() {
      this.apiSearchForm.apiName = '';
      this.apiCurrentPage = 1;
      this.getApiList();
    },
    handleApiSizeChange(val) {
      this.apiPageSize = val;
      this.apiCurrentPage = 1;
      this.getApiList();
    },
    handleApiCurrentChange(val) {
      this.apiCurrentPage = val;
      this.getApiList();
    },
    handleApiSelectionChange(selection) {
      this.selectedApiIds = selection.map(item => item.id);
    },
    batchRevoke() {
      let that = this;
      if (that.selectedApiIds.length === 0) {
        ElMessage({
          message: '请选择要撤销的API',
          type: 'warning',
        });
        return;
      }
      let param = {
        appId: that.detailInfo.id,
        apiIds: that.selectedApiIds
      };
      that.$axios.post("open-server/openapi/admin/apps/apiPermissions/del", JSON.stringify(param)).then(result => {
        if (result.code == 200) {
          ElMessage({
            message: '撤销成功',
            type: 'success',
          });
          that.selectedApiIds = [];
          that.$refs.apiTableRef.clearSelection();
          that.getApiList();
        }
      });
    },
    getStationList() {
      let that = this;
      let param = {};
      param.page = that.stationCurrentPage;
      param.pageSize = that.stationPageSize;
      param.name = that.stationSearchForm.name;
      param.appId = that.detailInfo.id;
      that.$axios.post("open-server/openapi/station/listByAppId", JSON.stringify(param)).then(result => {
        if (result.code == 200) {
          that.stationTableData = result.data.records;
          that.stationTotal = result.data.total;
        }
      });
    },
    searchStationList() {
      this.stationCurrentPage = 1;
      this.getStationList();
    },
    resetStationSearch() {
      this.stationSearchForm.name = '';
      this.stationCurrentPage = 1;
      this.getStationList();
    },
    handleStationSizeChange(val) {
      this.stationPageSize = val;
      this.stationCurrentPage = 1;
      this.getStationList();
    },
    handleStationCurrentChange(val) {
      this.stationCurrentPage = val;
      this.getStationList();
    },
    handleStationSelectionChange(selection) {
      this.selectedStationIds = selection.map(item => item.stationId);
    },
    batchRevokeStation() {
      let that = this;
      if (that.selectedStationIds.length === 0) {
        ElMessage({
          message: '请选择要撤销的场站',
          type: 'warning',
        });
        return;
      }
      let param = {
        appId: that.detailInfo.id,
        stationIds: that.selectedStationIds
      };
      that.$axios.post("open-server/openapi/admin/apps/stationPermissions/del", JSON.stringify(param)).then(result => {
        if (result.code == 200) {
          ElMessage({
            message: '撤销成功',
            type: 'success',
          });
          that.selectedStationIds = [];
          that.$refs.stationTableRef.clearSelection();
          that.getStationList();
        }
      });
    },
    getMethodType(method) {
      const typeMap = {
        'GET': '',
        'POST': 'success',
        'PUT': 'warning',
        'DELETE': 'danger'
      };
      return typeMap[method] || '';
    },
    goBack() {
      this.$router.push('/thirdappmanagement');
    },
  }
};
</script>

<style lang="scss" scoped>
.third-app-detail {
  padding: 20px;
  .box-card {
    margin-bottom: 20px;
    .card-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .card-title {
        font-size: 16px;
        font-weight: bold;
      }
    }
  }
  .api-card {
    .api-permission-actions {
      margin-bottom: 15px;
      display: flex;
      align-items: center;
      gap: 10px;
      .selected-count {
        color: #409eff;
        font-size: 14px;
      }
    }
    .search-form {
      margin-bottom: 15px;
    }
  }
  .station-card {
    .api-permission-actions {
      margin-bottom: 15px;
      display: flex;
      align-items: center;
      gap: 10px;
      .selected-count {
        color: #409eff;
        font-size: 14px;
      }
    }
    .search-form {
      margin-bottom: 15px;
    }
  }
}
</style>